import NotificationCard from "./NotificationCard";

export default function GenericFileNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="file"
            destination={"/file/" + props.notification.file}
            showComments
        />
    );
}
